"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Value = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formatPrice = require("../../utils/formatPrice");
var Value = function Value(_ref) {
  var className = _ref.className,
    currency = _ref.currency,
    price = _ref.price;
  var rootClassName = (0, _classnames["default"])('cds-Price-Value', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, currency || '', " ", /*#__PURE__*/_react["default"].createElement("strong", null, (0, _formatPrice.formatPrice)(price)));
};
exports.Value = Value;